/*
 * @Description: 防抖
 * @Author: guqiang
 * @Date: 2021-09-24 17:34:24
 * @LastEditors: guqiang
 * @LastEditTime: 2021-09-24 17:53:10
 */
let timeout = null;
export default function (func, wait = 500, immediate = true) {
    // 清除定时器
    if (timeout !== null) clearTimeout(timeout);
    // 立即执行，此类情况一般用不到
    if (immediate) {
        var callNow = !timeout;
        timeout = setTimeout(function () {
        timeout = null;
        }, wait);
        if (callNow) typeof func === 'function' && func();
    } else {
        // 设置定时器，当最后一次操作后，timeout不会再被清除，所以在延时wait毫秒后执行func回调方法
        timeout = setTimeout(function () {
        typeof func === 'function' && func();
        }, wait);
    }
}
